<div class="payment-grid-container">
  <h2 class="payment-title">Payment Information</h2>
  <div class="payment-grid">
    <div class="payment-option" *ngFor="let option of paymentOptions">
      <img [src]="option.image" [alt]="option.name" class="payment-image" />
      <p class="payment-name">{{ option.name }}</p>
      <small>
        <span *ngIf="option.prefix" style="color: #ff4d06; font-weight: bold;">{{option.prefix}}</span>{{option.price | currency: 'Rs. ' : 'symbol' : '1.0-0'}}
        <br *ngIf="option.total" />
        <span *ngIf="option.total" style="font-weight: bold; color: #4b5563;">Total: {{option.total | currency: 'Rs. ' : 'symbol' : '1.0-0'}}</span>
      </small>
    </div>
  </div>

</div>